module.exports = require('./dist/vue-lightbox.js')



//////////////////
// WEBPACK FOOTER
// ./~/vue-lightbox/index.js
// module id = 157
// module chunks = 0